module.exports = __webpack_public_path__ + "static/media/campeonato_06.fedef435.jpg";